// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-checkpoint-answer .mat-mdc-cell {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./Source/app/system-notifications/checkpoint-answer/checkpoint-answer.component.scss"],"names":[],"mappings":"AACI;EACI,eAAA;AAAR","sourcesContent":[".fi-checkpoint-answer {\r\n    .mat-mdc-cell {\r\n        cursor: pointer;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
